/**
 * The keyboard connect check, asked for from anywhere (the input picker) and
 * run by the MIDI provider, which knows whether a keyboard is connected and
 * draws the connect prompt. Kept apart from the provider so a screen can ask
 * for it without loading the whole MIDI stack.
 */
type ConnectCheckRunner = () => void;

const runners = new Set<ConnectCheckRunner>();

/** Ask the player to connect their MIDI keyboard if none is connected. */
export const requestMidiConnectCheck = (): void => {
  runners.forEach((run) => run());
};

/** Run the check when it is asked for. Returns the unsubscribe. */
export const onMidiConnectCheckRequest = (run: ConnectCheckRunner): (() => void) => {
  runners.add(run);
  return () => {
    runners.delete(run);
  };
};
